import $ from "jquery";

class commentReply {
  constructor() {
    this.pagebaseurl = $("main").data("url");

    this.replybut = $(".reply");
    this.commentid = this.replybut.data("commentid");
    this.replyto = $("#replyto");
    this.parentid = $("input[name=parentid]");
    this.postid = $("input[name=postid]");
    this.wholescreen = $("html, body");
    this.addcomment = $("#addcomment");

    this.upScore = $(".commentpoint .fa-arrow-circle-up");
    this.downScore = $(".commentpoint .fa-arrow-circle-down");
    this.commentPoint = this.upScore.parent();
    this.commentPoint2 = this.downScore.parent();
    this.commentPointID = this.commentPoint.data("commentid");
    this.commentPointID2 = this.commentPoint2.data("commentid");
    this.pointpos = this.commentPoint.find(".pointpos");
    this.pointneg = this.commentPoint.find(".pointneg");
    this.pointposscore = parseInt(this.pointpos.html());
    this.pointnegscore = parseInt(this.pointneg.html());

    this.addComment = $("#addcomment");
    this.addCommentForm = $("#addcommentform");
    this.addCommentFormName = $("#addcommentform input[name=name]");
    this.addCommentFormEmail = $("#addcommentform input[name=email]");
    this.addCommentFormBody = $("#addcommentform #commentbody");
    this.addCommentFormCaptcha = $("#addcommentform input[name=captcha]");
    this.addCommentMSG = $("#addcommentmsg");
    this.addCommentNameError = $("#nameerr");
    this.addCommentCaptchaError = $("#captchaerr");

    this.events();
  }

  events() {
    this.replybut.on("click", this.replyToComment.bind(this));
    this.upScore.on("click", this.plusScore.bind(this));
    this.downScore.on("click", this.minusScore.bind(this));
    this.addCommentForm.on("submit", this.sendComment.bind(this));
  }

  replyToComment() {
    this.replyto.load(pagebaseurl + "ajax/repcomment.php?id=" + this.commentid).show();
    parentid.val(this.commentid);
    this.wholescreen.animate(
      {
        scrollTop: this.addcomment.offset().top,
      },
      500
    );
  }

  plusScore() {
    this.pointposscore += 1;
    this.commentPoint.load(pagebaseurl + "ajax/commentpoints.php?commentid=" + this.commentPointID + "&pointpos=" + this.pointposscore + "&pointneg=" + this.pointnegscore);
    this.wholescreen.animate(
      {
        scrollTop: this.commentPoint.parent().parent().offset().top - 50,
      },
      100
    );
  }

  minusScore() {
    this.pointnegscore += 1;
    this.commentpoint2.load(pagebaseurl + "ajax/commentpoints.php?commentid=" + this.commentPointID2 + "&pointpos=" + this.pointposscore + "&pointneg=" + this.pointnegscore);
    this.wholescreen.animate(
      {
        scrollTop: this.commentPoint.parent().parent().offset().top - 50,
      },
      100
    );
  }

  sendComment(e) {
    e.preventDefault();
    if (this.addCommentFormName.val() === "") {
      this.addCommentNameError.html("لطفا نام خود را وارد نمایید.");
    }
    if (this.addCommentFormCaptcha.val() === "") {
      this.addCommentCaptchaError.html("لطفا کد امنیتی را بطور صحیح وارد نمایید.");
    }
    if (this.addCommentFormName.val() !== "" && this.addCommentFormCaptcha.val() !== "") {
      this.addCommentForm.hide();
      this.addCommentMSG.html('<span>لطفا کمی صبر فرمایید... </span><i class="fa fa-refresh fa-spin" style="font-size:24px"></i>');
      $.ajax({
        url: "../ajax/addcomment.php",
        type: "POST",
        data: {
          name: this.addCommentFormName.val(),
          message: this.addCommentFormBody.val(),
          captcha: this.addCommentFormCaptcha.val(),
          email: this.addCommentFormEmail.val(),
          postid: this.postid.val(),
          parentid: this.parentid.val(),
        },
        success: function (data) {
          this.addCommentMSG.html(data);
        }.bind(this),
      });
    }

    $("html, body").animate(
      {
        scrollTop: this.addComment.offset().top - 50,
      },
      200
    );
  }
}

export default commentReply;
